import { PlatformAlias } from '@mybonus/public';
import { z } from 'zod';

export const Env = z.object({
	APP_PLATFORM_ALIAS: PlatformAlias,
	APP_VERSION: z.string(),
	APP_ENV: z.enum(['local', 'dev', 'master']),
	SENTRY_DSN: z.string(),
	API_BASE_URL: z.string(),
	WEB_BASE_URL: z.string(),
	CDN_URL: z.string(),
	FB_APP_ID: z.string(),
});
export type Env = z.infer<typeof Env>;

export const env = Env.parse({
	APP_ENV: __MYBONUS_ENV__.APP_ENV,
	APP_VERSION: __MYBONUS_ENV__.APP_VERSION,
	APP_PLATFORM_ALIAS: __MYBONUS_ENV__.APP_PLATFORM_ALIAS,
	SENTRY_DSN: __MYBONUS_ENV__.SENTRY_DSN,
	API_BASE_URL: __MYBONUS_ENV__.API_BASE_URL,
	WEB_BASE_URL: __MYBONUS_ENV__.WEB_BASE_URL,
	CDN_URL: __MYBONUS_ENV__.WEB_BASE_URL,
	FB_APP_ID: __MYBONUS_ENV__.FB_APP_ID,
});
